function isPositiveInt(v) {
  const n = Number(v)
  return Number.isFinite(n) && n > 0
}

export default {
  paso1PrestadoresIdsParaCalendario(state) {
    const s = state.paso1Seleccion
    if (!s) return []
    if (isPositiveInt(s.profesionalId)) return [Number(s.profesionalId)]
    return Array.isArray(s.prestadoresIdsCargados)
      ? s.prestadoresIdsCargados.map((x) => Number(x)).filter(isPositiveInt)
      : []
  },
  paso1BloquearAvance(state, getters, rootState) {
    const s = state.paso1Seleccion
    if (!s) return true
    if (!isPositiveInt(s.osId)) return true
    if (!isPositiveInt(s.planId)) return true
    if (!isPositiveInt(s.especialidadId)) return true
    const p = s.practica
    if (!p || !isPositiveInt(p.nomId) || !String(p.nomCod ?? '').trim()) return true
    if (getters.paso1PrestadoresIdsParaCalendario.length === 0) return true
    // En modo invitado, además se piden fecha de nacimiento y género.
    const guest = rootState?.guestSession
    if (guest?.activo === true) {
      const tdId = Number(guest?.tdId)
      const nroDoc = String(guest?.nroDoc ?? '').trim()
      const apellido = String(guest?.apellido ?? '').trim()
      const nombre = String(guest?.nombre ?? '').trim()
      const fNac = String(guest?.fechaNacimiento ?? '').trim()
      const sexo = String(guest?.sexo ?? '').trim()
      if (!Number.isFinite(tdId) || tdId <= 0) return true
      if (!nroDoc) return true
      if (!apellido) return true
      if (!nombre) return true
      if (!fNac) return true
      if (sexo !== 'F' && sexo !== 'M') return true
    }
    return false
  },
  paso2BloquearAvance(state) {
    if (state.paso2ResumenLoading || state.paso2ResumenFetchEnCurso) return true
    const rows = state.sedesConTurnoDisponible
    if (rows.length === 0) return true
    if (rows.length === 1) {
      const s = rows[0]
      if (!s.hayPresencial && !s.hayVideo) return true
    }
    const ubi = state.paso2Seleccion?.ubicId
    if (ubi == null) return true
    const sede = rows.find((x) => x.id === ubi || String(x.id) === String(ubi))
    if (!sede) return true
    if (!sede.hayPresencial && !sede.hayVideo) return true
    const mod = state.paso2Seleccion?.modalidad
    if (mod !== 'presencial' && mod !== 'video') return true
    if (sede.hayPresencial && !sede.hayVideo && mod !== 'presencial') return true
    if (!sede.hayPresencial && sede.hayVideo && mod !== 'video') return true
    return false
  },
  paso3BloquearAvance(state) {
    return !state.paso3SlotSeleccionado
  },
  paso4BloquearAvance(state, _getters, rootState) {
    if (!state.paso4ContactoListo) return true
    const fichaId = Number(state.paso1Seleccion?.pacienteFichaId)
    const esModoInvitado = rootState?.guestSession?.activo === true
    const esFamiliar = !esModoInvitado && Number.isFinite(fichaId) && fichaId > 0
    if (esFamiliar && state.paso1Seleccion?.pacienteVinculoConfirmado !== true) {
      return false
    }
    const email = String(state.paso4Contacto?.email ?? '').trim()
    if (email === '') return true
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    return !re.test(email)
  },
}
